{
  "list": {
    "title": "Families",
    "newFamily": "New Family",
    "memberOne": "{count} member",
    "memberMany": "{count} members",
    "noContact": "no contact",
    "noFamilies": "No families yet.",
    "selectEmptyHeading": "Select a family",
    "selectEmptyMessage": "Pick a family on the left, or create one."
  },
  "form": {
    "nameLabel": "Family name",
    "namePlaceholder": "e.g. Vinatoru family",
    "create": "Create",
    "deleteFamily": "Delete family"
  },
  "members": {
    "heading": "Members",
    "setContactWarning": "⚠ Set a billing contact — family fees are billed to them.",
    "billingContactBadge": "billing contact",
    "makeContact": "Make contact",
    "remove": "Remove",
    "noMembers": "No members yet.",
    "addStudentLabel": "Add a student",
    "searchPlaceholder": "Search by name or email…",
    "add": "Add"
  },
  "fees": {
    "heading": "Family fees",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "e.g. Costume fee",
    "typeLabel": "Type",
    "amountLabel": "Amount",
    "currencyLabel": "Currency",
    "dueDayLabel": "Due day",
    "familyFeeLabel": "Family fee",
    "familyFeePlaceholder": "Choose a family fee…",
    "addCharge": "Add charge",
    "addFee": "Add fee",
    "linkSharedInstead": "Link a shared family fee instead",
    "addCustomCharge": "+ Add a custom charge",
    "noShared": "No shared family fees defined — pick “Add a custom charge”, or create one in Settings → Billing (Billed: Per family).",
    "customCharge": "custom charge",
    "amountPerPeriod": "{amount}/period",
    "noneSet": "No family fees set."
  },
  "payments": {
    "heading": "Payments",
    "generateThisMonth": "Generate this month",
    "record": "Record",
    "emptyHeading": "No family payments yet",
    "emptyMessage": "Set a fee + billing contact, then generate.",
    "recordModalHeading": "Record payment",
    "paymentFallback": "Payment",
    "paidVia": "Paid via",
    "methodDefault": "{name} (default)",
    "referenceLabel": "Reference (optional)",
    "referencePlaceholder": "e.g. transfer ref / receipt no.",
    "notesLabel": "Notes (optional)",
    "noEnabledMethods": "No enabled payment methods — add one in Settings → Billing.",
    "recordPayment": "Record payment",
    "col": {
      "due": "Due",
      "fee": "Fee",
      "amount": "Amount",
      "method": "Method",
      "status": "Status"
    }
  },
  "feeType": {
    "monthly": "Monthly",
    "yearly": "Yearly",
    "occasional": "Occasional",
    "event": "Event"
  },
  "toast": {
    "failed": "Failed",
    "familyDeleted": "Family deleted",
    "contactSet": "Billing contact set",
    "enterChargeDetails": "Enter a description and amount for the custom charge",
    "chooseFee": "Choose a family fee",
    "feeSet": "Family fee set",
    "paymentsGenerated": "{count} payment(s) generated",
    "chooseMethod": "Choose a payment method",
    "paymentRecorded": "Payment recorded"
  }
}
